const content = {
  heading: ['login_title'],
  text: 'login_subtitle',
  bulletpoint1: 'login_bullet_1',
  bulletpoint2: 'login_bullet_2',
  bulletpoint3: 'login_bullet_3',
}

export default content
